import * as v from 'valibot';
import { MarketplaceStatusEnum } from '@repo/supergraph/marketplace/enums';
import {
  ctaSchema,
  entityTypeSchema,
  MonetizableEnumSchema,
} from '@repo/supergraph/marketplace/schema';
import { nulltoOptional } from '@repo/supergraph/utils/validation-utils';

export const marketplaceEntitySchema = v.object({
  id: v.string(),
  name: v.string(),
  entityType: nulltoOptional(entityTypeSchema),
  productType: v.string(),
  monetizable: MonetizableEnumSchema,
  cta: nulltoOptional(ctaSchema),
  status: v.enum(MarketplaceStatusEnum),
  product: v.object({
    id: v.string(),
    name: nulltoOptional(v.string()),
    institution: v.object({
      id: v.string(),
      name: nulltoOptional(v.string()),
      displayName: nulltoOptional(v.string()),
    }),
  }),
  reviewLink: nulltoOptional(v.pipe(v.string(), v.url())),
});
